import { render } from "./Calculations.vue?vue&type=template&id=43017a96"
import script from "./Calculations.vue?vue&type=script&lang=ts"
export * from "./Calculations.vue?vue&type=script&lang=ts"
script.render = render

export default script